import React, { useEffect, useState } from "react";
import images from "../../../../utilities/images/images";
import "./QuestionText.css";
import ShakaSolutionViewVideoPlayer from
  "../../../../custom_utilities/shakaVideoPlayer/ShakaSolutionViewVideoPlayer";
export default function QuestionText({ data }) {
  const [activeTab, setActiveTab] = useState("text");
  useEffect(() => {
    setActiveTab("text");
  }, [data?.qid, data?.display_number]);

  if (!data) return null;

  const { q_text, type, toughness, option = [], sol_text, video_id_english, display_number } = data;


  const computeQuestionStatus = () => {
    let userAttempted = false;
    let userSelectedCorrect = false;
    if (option && Array.isArray(option)) {
      option.forEach((opt) => {
        if (opt.is_user_correct_ans === 1) {
          userAttempted = true;
          if (opt.is_correct === 1) {
            userSelectedCorrect = true;
          }
        }
      });
    } else if (data.user_answer === "WRONG") {
      userAttempted = true;
      userSelectedCorrect = false;
    }
    if (userAttempted) {
      return userSelectedCorrect ? "correct" : "incorrect";
    }
    return "unattempted";
  };

  const questionStatus = computeQuestionStatus();

  return (
    <div className="questionText_wrapper">
      {/* Question Header */}
      {/* <div className="question_header">
        <h4>
          Q.{display_number} | {type}
        </h4>
        <div className="difficulty_tags">
          <span className="tag difficulty">{toughness}</span>
          <span className={`tag status ${questionStatus}`}>
            {questionStatus === "correct" ? (
              <>
                <img src={images.tick_icon} alt="tick" className="tick-icon" />
                Correct
              </>
            ) : questionStatus === "incorrect" ? (
              "Incorrect"
            ) : (
              "Unattempted"
            )}
          </span>
        </div>
      </div> */}

      {/* Question HTML */}
      <div
        className="question_html"
        dangerouslySetInnerHTML={{ __html: q_text }}
      />

      {/* Options */}
      <div className="options_wrapper">
        {option.map((opt) => {
          const isCorrect = opt.is_correct === 1;
          const isUserAnswer = opt.is_user_correct_ans === 1;
          const isUserWrong = isUserAnswer && !isCorrect; // ✅ New: User selected wrong
          return (
            <div
              key={opt.option_id}
              className={`option ${isCorrect ? "correct" : ""} ${isUserWrong ? "user-wrong" : ""}`}
            >
              <input type="radio" checked={isUserAnswer} readOnly />
              <span dangerouslySetInnerHTML={{ __html: opt.option }} />
              {isUserAnswer && (
                <span className={`your_answer_tag ${isCorrect ? "correct" : "wrong"}`}>
                  <img
                    src={isCorrect ? images.tick_icon : images.Wrong} // ✅ Dynamic icon
                    alt={isCorrect ? "tick" : "cross"}
                    className="questionGrid-icon"
                  />
                  Your answer
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* Solution Section */}
      <div className="solution_wrapper">
        <h5>Solution:</h5>
        <div className="solution_tabs">
          <button
            className={`tab_btn ${activeTab === "text" ? "active" : ""}`}
            onClick={() => setActiveTab("text")}
          >
            Text
          </button>
          {video_id_english && (
            <button
              className={`tab_btn ${activeTab === "video" ? "active" : ""}`}
              onClick={() => setActiveTab("video")}
            >
              Video
            </button>
          )}
        </div>
        <div className="solution_content">
          {activeTab === "text" && (
            <div
              className="solution_text"
              dangerouslySetInnerHTML={{ __html: sol_text }}
            />
          )}

          {activeTab === "video" && video_id_english && (
            <div className="solution_video">
              <ShakaSolutionViewVideoPlayer
                key={`${video_id_english}-${display_number}`}
                id_video={video_id_english}
                className="shakaPlayer"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}